import { THEMES } from "../../../../themes/constants";
export const getVehicleColor = (isVehicleElectric, themeName) => {
  if (isVehicleElectric) {
    return "#1D8C23";
  }

  if (themeName === THEMES.BLUE_LIGHT || themeName === THEMES.BLUE_DARK) {
    return "#3e8af0";
  }

  return "#DC0032";
};